import * as React from "react";
import { DiscountInfoBox } from "./styles";
import CountDown from "../../CountDown";
import { PoolExtraFlashInfo, ExtraIconPro } from "../../../../../services/product";

interface DiscountInfoCardLTProps {
	discountInfo?: ExtraIconPro;
	tagInfo?: ExtraIconPro;
	themeTag?: ExtraIconPro;
	className?: string;
	flash?: PoolExtraFlashInfo;
}
export default class DiscountInfoCard extends React.PureComponent<DiscountInfoCardLTProps> {
	getStyle = (item: ExtraIconPro) => {
		return { height: item?.height || "auto" };
	};
	renderImgOnTopLeft = () => {
		if (this.props.discountInfo?.img) {
			return (
				<img
					className={"discountIcon"}
					src={this.props.discountInfo.img}
					alt=""
					style={this.getStyle(this.props.discountInfo)}
				/>
			);
		}
		return null;
	};
	renderImgOnTopRight = () => {
		if (this.props.tagInfo?.img) {
			return (
				<img
					className={"descImg"}
					src={this.props.tagInfo.img}
					alt=""
					style={this.getStyle(this.props.tagInfo)}
				/>
			);
		}
		return null;
	};
	renderImgOnBottomLeft = () => {
		if (this.props.themeTag?.img) {
			return <img className={"themeTag"} src={this.props.themeTag.img} alt="" />;
		}
		return null;
	};
	render() {
		const { discountInfo, tagInfo, themeTag, className = "", flash } = this.props;
		if (!discountInfo && !tagInfo && !themeTag) {
			return null;
		}
		return (
			<DiscountInfoBox className={`${className}`}>
				{this.renderImgOnTopLeft()}
				{this.renderImgOnTopRight()}
				{this.renderImgOnBottomLeft()}
				{flash?.countdownToEnd && <CountDown countInfo={flash} />}
			</DiscountInfoBox>
		);
	}
}
